import { useMemo } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Search from './Search';
import Message from './Message';
import Profile from './Profile';
import Localization from './Localization';
import Notification from './Notification';
import Wallet from './wallet';
import FullScreen from './FullScreen';
import MobileSection from './MobileSection';
import MegaMenuSection from './MegaMenuSection';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';
import LanguageSelector from './language';
import { getDashboardData } from '../../../../helper/getDashboardData';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {

  const { menuOrientation } = useConfig();

  const dashboardData = useMemo(() => getDashboardData(), []);
  const role = dashboardData?.userType;

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const localization = useMemo(() => <Localization />, []);
  const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
        {/* {!downLG && <Search />} */}
        {/* {!downLG && megaMenu}
        {!downLG && localization}
        {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

        <Message />
        {!downLG && <FullScreen />} */}
        {/* <LanguageSelector /> */}
        {role !== 'ROLE_SUPER_ADMIN' && <Wallet />}
        <Notification />
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Box>
    </>
  );
}
